export default "__VITE_ASSET__NBqoFNwH__"